import type { ChangelogEntry } from "../types";

/** VIB-2795. Tospaltet tre, fast verktøylinje, dokumentet som ark. */
export const DOKUMENTEDITOR_ARK_2026_10: ChangelogEntry = {
  id: "2026-10-06-dokumenteditor-ark",
  date: "2026-10-06",
  title: "Dokumentarkivet har fått ny utforming",
  summary:
    "Mapper og dokumenter står nå i det samme treet, verktøylinja står fast over teksten, og dokumentet vises som et ark.",
  sections: [
    {
      heading: "Dokumentarkiv",
      items: [
        {
          title: "Mapper og dokumenter i ett tre",
          kind: "forbedret",
          body: "Før sto mappene i én kolonne og dokumentene i en annen, så du måtte se to steder for å finne én ting. Nå folder dokumentene seg ut under mappa du velger, og dokumentet får hele plassen til høyre.",
        },
        {
          title: "Verktøylinja står fast",
          kind: "forbedret",
          body: "Den kom før fram bare når du markerte tekst. Nå står den over arket hele tiden, og helt til venstre ser du hva slags avsnitt du står i, enten det er vanlig tekst eller en overskrift.",
        },
        {
          title: "Skillelinje",
          kind: "nytt",
          body: "Du kan sette inn en vannrett strek for å skille to deler av et dokument.",
        },
        {
          title: "Bilde kan velges fra verktøylinja",
          kind: "nytt",
          body: "Før måtte du dra bildet inn eller lime det inn. Nå finnes det også en bilde-knapp som åpner filvelgeren.",
        },
        {
          title: "Dokumentet leses som et ark",
          kind: "forbedret",
          body: "Teksten står på et hvitt ark som fyller bredden, og det ser likt ut mens du skriver og etter at du har lagret.",
        },
        {
          title: "Overskrifter ser ut som overskrifter",
          kind: "rettet",
          body: "Overskrift 2 og Overskrift 3 var like store som vanlig tekst, så det eneste som skilte dem var at du visste hva du hadde trykket på. Nå har de hver sin størrelse, og punktlister har fått tilbake kulepunktene.",
        },
        {
          title: "Innholdsfortegnelse i margen",
          kind: "nytt",
          body: "Har dokumentet overskrifter, står de i en liste til venstre for arket. Klikk på en linje for å hoppe dit. Lista lages av overskriftene selv, så den kan ikke komme ut av takt med teksten, og den kan legges sammen når du ikke trenger den.",
        },
        {
          title: "Rediger, Del og Slett ligger i en meny",
          kind: "forbedret",
          body: "De lå som knapper under dokumentet du hadde valgt. Nå ligger de bak «...» på dokumentets egen rad.",
        },
      ],
    },
  ],
};
